import CompanyInformationTable from './company-information/company-information-table';
import InsuranceCompanySelectorTable from './insurance-selector/insurance-company-selector';
import PropTypes from 'prop-types';
import QuotationAvailableByCarsTable from './quotation-available-by-car/quotation-available-by-car';
import QuotationByCarCategory from './quotation-by-car-category/quotation-by-car-category';
import Top5InsuranceTable from './top-5-insurance/top-5-insurance';
import { useCulture } from 'context/CultureContext';
import { useInsuranceFamilyCodeContext } from 'components/landing/context/insurance-family-code-context';
import { usePageInfo } from 'context/PageInfoContext';

/**
 * @component
 * @param {("top_5_insurance"|"insurance_company_selector"|"quotation_available_by_car"|"company_profile_table")} tableName - The table is
 *
 */
const LandingTable = ({ tableName, tableData, colorSchema = '#3F4E89' }) => {
    const { pageInfo } = usePageInfo();
    const { familyCode } = useInsuranceFamilyCodeContext();
    const { culture } = useCulture();

    const companyCode =
        pageInfo.page_context &&
        pageInfo.page_context.page_config &&
        pageInfo.page_context.page_config.company_code;
    const defFamilyCode = familyCode;

    let data = null;

    if (tableName === 'top_5_insurance') {
        data = pageInfo && pageInfo.top_5[defFamilyCode];

        return (
            <Top5InsuranceTable
                data={data}
                culture={culture}
                familyCode={defFamilyCode}
            />
        );
    } else if (tableName === 'insurance_company_selector') {
        data = pageInfo && pageInfo.related_insurers;

        return <InsuranceCompanySelectorTable culture={culture} data={data} />;
    } else if (tableName === 'quotation_available_by_car') {
        return (
            <QuotationAvailableByCarsTable
                colorSchema={colorSchema}
                culture={culture}
                companyCode={companyCode || ''}
                data={tableData}
            />
        );
    } else if (tableName === 'quotation-by-car-category') {
        return (
            <QuotationByCarCategory
                colorSchema={colorSchema}
                culture={culture}
                companyCode={companyCode || ''}
                data={tableData}
            />
        );
    } else if (tableName === 'company_profile_table') {
        return (
            <CompanyInformationTable
                data={tableData}
                colorSchema={colorSchema}
            />
        );
    } else if (tableName === '') {
        return null;
    }

    return null;
};

LandingTable.propTypes = {
    tableName: PropTypes.string.isRequired,
    tableData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    colorSchema: PropTypes.string
};

export default LandingTable;
